import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Education } from './education';

export interface EducationStore {
  loaded$: Observable<boolean>;
  allItems$: Observable<Education[]>;
  selectedItem$?: Observable<Education | undefined>;

  load(): Observable<Education[]>;
  addItem?(education: Education): void;
  editItem(education: Education): void;
  deleteItem(education: Education): void;
  editOrAddSuccess(): Observable<unknown>;
}

export const EDUCATION_STORE = new InjectionToken<EducationStore>(
  'EDUCATION_STORE',
);
